<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <Title tag="h1" v-if="section">{{ paramType }}</Title>
          <Title tag="h1" v-if="section">{{ section.title }} </Title>
          <Title tag="h1" v-else>Sección no encontrada</Title>
          <div v-if="paramType == 'testimonios'" class="practicantes__list">
            <Row
              v-for="(practicante, index) in demoFilterPracticantes(demoYear)"
              :key="index"
            >
              <ColumnUi md="4" sm="12" v-show="practicante.photo != '-'">
                <img
                  class="article__thumb thumbnail"
                  :alt="`Foto de ${practicante.name}`"
                  :src="practicante.photo"
                />
              </ColumnUi>
              <ColumnUi md="8" sm="12">
                <h2>{{ practicante.name }}</h2>
                <List>
                  <li v-if="practicante.specialty != '-'">
                    {{ practicante.specialty }}
                  </li>
                  <li>{{ practicante.university }}</li>
                </List>
                <br />
                <p v-if="practicante.description != '-'">
                  "{{ practicante.description }}"
                </p>
              </ColumnUi>
            </Row>
          </div>
          <div v-if="paramType == 'proyectos'" class="practicantes__list">
            <Row
              v-for="(practicante, index) in demoFilterPracticantes(demoYear)"
              :key="index"
              v-show="practicante.project[0].title !== ''"
            >
              <ColumnUi md="4" sm="12" v-show="practicante.photo != '-'">
                <img
                  class="article__thumb thumbnail"
                  :alt="`Foto de ${practicante.name}`"
                  :src="practicante.photo"
                />
              </ColumnUi>
              <ColumnUi md="8" sm="12">
                <h3 style="text-transform: initial">
                  <b>
                    {{ practicante.project[0].title }}
                  </b>
                </h3>
                <p>
                  <b>Responsable: </b>
                </p>
                <List>
                  <li>{{ practicante.name }}</li>
                  <li v-if="practicante.specialty != '-'">
                    {{ practicante.specialty }}
                  </li>
                  <li>{{ practicante.university }}</li>
                </List>
                <br />
              </ColumnUi>
              <div style="padding: 0px 25px 0px 20px;">
                <p>
                  <b>Resumen:</b>
                </p>
                <p style="text-align: justify;">
                  {{ practicante.project[0].abstract }}
                </p>
                <a
                  v-if="practicante.project[0].link != '-'"
                  class="btn-practicante"
                  :href="practicante.project[0].link"
                  target="_blank"
                  >Seguir Leyendo</a
                >
              </div>
            </Row>

            <!-- <Content :content="section.content" /> -->
            <hr />
          </div>
        </ColumnUi>
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(section, index) in sections" :key="index">
              <router-link
                v-if="!section || currentSectionSlug != section.href"
                :to="section.href"
              >
                {{ section.title }}
              </router-link>
              <span v-else>
                {{ section.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getLaboratories } from "@/practicantes.js";
import { demo } from "@/practicants.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
// import Content from "@/components/common/Content.vue";
import { useRoute } from "vue-router";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    // Content,
  },
  setup() {
    const paramType = useRoute().params.type;
    const currentSectionSlug = useRoute().fullPath;
    const paramSection = useRoute().params.anho;
    // Filtrar los practicantes según el año
    const laboratory = getLaboratories(process.env.VUE_APP_PREFIX)[paramType];
    // const sections = ["testimonios", "proyectos"];
    const sections = [];
    laboratory.forEach((section) => {
      sections.push({
        title: section.title,
        href: `/nuestros-practicantes/${paramType}/${section.slug}`,
      });
    });

    const section =
      laboratory && laboratory.find((section) => section.slug == paramSection);

    // Nueva versión
    const demoPracticantes = [];
    const demoProjects = [];
    const demoYear = useRoute().params.anho; // Obtenemos el año

    const demoFilterPracticantes = (anho) => demo[anho]?.practicantes || [];
    demo[demoYear].practicantes.forEach((practicante) => {
      demoProjects.push(practicante.project);
    });

    return {
      section,
      sections,
      laboratory,
      paramType,
      currentSectionSlug,
      demoPracticantes,
      demoFilterPracticantes,
      demoYear,
    };
  },
};
</script>

<style lang="scss" scope>
@use "@/assets/styles/settings/_variables.scss";
.practicantes__list {
  display: grid;
  grid-template-columns: repeat(1fr);
  gap: 2em;
}

.btn-practicante {
  text-decoration: none;
  padding: 10px 15px;
  border: 2px solid variables.$primary-color;
  &:hover {
    background-color: variables.$primary-color;
    color: white;
    text-decoration: none;
  }
}
</style>
